import { PHOTO_API_URL } from "./const";

const photoApi = {
  upload: (file) => {
    const token = localStorage.getItem("token");
    const formdata = new FormData();
    formdata.append("photo", file);

    return fetch(`${PHOTO_API_URL}/upload`, {
      method: "POST",
      headers: {
        authorization: token,
      },
      body: formdata,
      redirect: "follow",
    }).then((response) => response.json());
  },
  uploadCover: (formId, file) => {
    const token = localStorage.getItem("token");
    const formdata = new FormData();
    formdata.append("photo", file);

    return fetch(`${PHOTO_API_URL}/uploadCover/${formId}`, {
      method: "POST",
      headers: {
        authorization: token,
      },
      body: formdata,
      redirect: "follow",
    }).then((response) => response.json());
  },
};

export default photoApi;